module.exports = __webpack_public_path__ + "static/media/PorCobrar.c8b12eba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo/PorCobrar.svg
// module id = 630
// module chunks = 34